import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Auth } from '@freelancer/auth';
import type { Subscription } from 'rxjs';
import { combineLatest, of, switchMap } from 'rxjs';
import { Hotjar } from './hotjar.service';
import { TrackingConsentStatus } from './interface';
import { TrackingConsent } from './tracking-consent.service';
import { Tracking } from './tracking.service';

@Component({
  standalone: false,
  selector: `fl-tracking-hotjar-user-attributes`,
  template: ` <ng-container></ng-container> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotjarUserAttributesComponent implements OnInit, OnDestroy {
  private auth = inject(Auth);
  private hotjar = inject(Hotjar);
  private tracking = inject(Tracking);
  private trackingConsent = inject(TrackingConsent);

  subscription?: Subscription;

  async ngOnInit(): Promise<void> {
    const trackingConsentStatus =
      await this.trackingConsent.getThirdPartyStatus();
    if (trackingConsentStatus !== TrackingConsentStatus.AUTHORIZED) {
      return;
    }

    this.subscription = combineLatest([
      this.auth
        .isLoggedIn()
        .pipe(
          switchMap(loggedIn =>
            loggedIn ? this.auth.getUserId() : of(undefined),
          ),
        ),
      this.tracking.getSessionId(),
    ]).subscribe(([userId, sessionId]) => {
      this.hotjar.sendUserAttributes(sessionId, userId);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
